// utility for mapping modules to nothing
export default null;
